import { hasRequiredProperty, useAutocomplete, type WithRequired } from 'admin';
import type { Material } from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export type MaterialWithName = WithRequired<Material, 'name'>;
export const isMaterialWithName = (material: Material): material is WithRequired<Material, 'name'> =>
  hasRequiredProperty(material, 'name') && material.name.length > 0;

export type MaterialAutocompleteProps = Omit<AutocompleteFieldProps<MaterialWithName>, 'options'>;

export const MaterialAutocomplete = (props: MaterialAutocompleteProps) => {
  const { autocompleteProps } = useAutocomplete<Material>({
    onSearch: (value) => [
      {
        field: 'search',
        operator: 'contains',
        value,
      },
    ],
    resource: '/materials/v1/materials/',
  });

  const { options, loading } = autocompleteProps;
  // TODO: move filtering to backend https://linear.app/safi/issue/TRADE-3478/materialsv1materials-returns-valid-materials
  const validOptions = options.filter(isMaterialWithName);

  return (
    <AutocompleteField<MaterialWithName>
      data-testid="material-autocomplete"
      getOptionLabel={(item) => item.name}
      loading={loading}
      groupBy={(option) => option.material_type_name}
      options={validOptions}
      valueField="id"
      {...props}
    />
  );
};
